import React from 'react';
import { Check, ChevronDown, ChevronRight, Clock, XIcon, Award } from 'lucide-react';
export function Sidebar({
  isOpen,
  onClose,
  isAssessmentComplete = false,
  isOnResultsScreen = false
}) {
  return <>
      {/* Overlay */}
      {isOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden" onClick={onClose} data-id="element-2046" data-mp="7w4zusjdjqma" />}
      {/* Sidebar */}
      
    </>;
}
function SidebarSection({
  title,
  items = [],
  expanded = false
}) {
  return <div className="mb-1" data-id="element-2047" data-mp="3v4qozeunfcly">
      <div className="flex items-center justify-between px-6 py-2 cursor-pointer hover:bg-gray-50" data-id="element-2048" data-mp="3qc7c6k3scli7">
        <div className="flex items-center" data-id="element-2049" data-mp="3lcbairik965t">
          <div className="w-5 h-5 rounded-full border border-gray-300 flex items-center justify-center mr-3" data-id="element-2050" data-mp="3lddxwpgocqgz">
            {expanded ? <ChevronDown size={16} data-id="element-2051" data-mp="3gbx0j3xefm55" /> : <ChevronRight size={16} data-id="element-2052" data-mp="3cbwk5dqqp0vg" />}
          </div>
          <span className="font-medium" data-id="element-2053" data-mp="3cbd3s1gqmkjj">{title}</span>
        </div>
      </div>
      {expanded && <div className="pl-6" data-id="element-2054" data-mp="37dlc98k090fv">
          {items.map((item, index) => <div key={index} className={`flex items-center py-2 px-6 ${item.active ? 'bg-blue-50' : 'hover:bg-gray-50'}`} data-id="element-2055" data-mp="1lz5e5kgd82iu" data-mpi={index}>
              <div className="w-5 h-5 rounded-full mr-3 flex items-center justify-center" data-id="element-2056" data-mp="1qr5lvz2ofzpz">
                {item.completed ? <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center" data-id="element-2057" data-mp="1d0jzi0e0l7nc">
                    <Check size={14} className="text-green-600" data-id="element-2058" data-mp="1h13tww77dx5s" />
                  </div> : item.icon ? <div className="w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-2059" data-mp="24rgdx5fq3kcq">
                    {item.icon}
                  </div> : <div className={`w-5 h-5 rounded-full border ${item.active ? 'border-blue-400' : 'border-gray-300'}`} data-id="element-2060" data-mp="29mvo9neiuy4e"></div>}
              </div>
              <span className="text-sm flex-1" data-id="element-2061" data-mp="20nid8qar21hk">{item.label}</span>
              {item.time && <div className="text-xs text-gray-500 flex items-center" data-id="element-2062" data-mp="k9s8rifpxb7e">
                  <Clock size={12} className="mr-1" data-id="element-2063" data-mp="kco36wscxhr3" />
                  {item.time}
                </div>}
            </div>)}
        </div>}
    </div>;
}